import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";

import "./styles/main.scss";
import i18n from "./i18n/i18n";
import store from "./rtk/_config/store";
import App from "./App";
import { AppRoutes } from "./routes/AppRoutes";
import Home from "./components/pages/Home/Home";
import ErrorPage from "./components/pages/ErrorPage/ErrorPage";
import Subscriptions from "./components/pages/Subscriptions/Subscriptions";
import Options from "./components/pages/Options/Options";
import Success from "./components/pages/Success/Success";
import Fail from "./components/pages/Fail/Fail";
import Unknown from "./components/pages/Unknown/Unknown";
import ManagePayments from "./components/pages/ManagePayments/ManagePayments";
import ManageSubscriptions from "./components/pages/ManageSubscriptions/ManageSubscriptions";
import ManageSubscriptionsEdit from "./components/pages/ManageSubscriptionsEdit/ManageSubscriptionsEdit";
import ManageSubscriptionsCancelReason from "./components/pages/ManageSubscriptionsCancelReason/ManageSubscriptionsCancelReason";
import ManageSubscriptionsCancelConfirm from "./components/pages/ManageSubscriptionsCancelConfirm/ManageSubscriptionsCancelConfirm";
import ManageSubscriptionEditResult from "./components/pages/ManageSubscriptionEditResult/ManageSubscriptionEditResult";
import ManageSubscriptionsRetentionOffers from "./components/pages/ManageSubscriptionsRetentionOffers/ManageSubscriptionsRetentionOffers";
import OrderTemplate from "./components/templates/Order/Order";
import { TransferTrackerOffer } from './components/pages/TransferTrackerOffer/TransferTrackerOffer';

const router = createBrowserRouter([
  {
    path: AppRoutes.BASE_ROUTE,
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        element: <OrderTemplate />,
        children: [
          {
            path: AppRoutes.SUBSCRIPTIONS,
            element: <Subscriptions />,
          },
          {
            path: AppRoutes.OPTIONS,
            element: <Options />,
          },
          {
            path: AppRoutes.FAIL,
            element: <Fail />,
          },
        ],
      },
      {
        path: AppRoutes.SUCCESS,
        element: <Success />,
      },
      {
        path: AppRoutes.MANAGE_PAYMENTS,
        element: <ManagePayments />,
      },
      {
        path: AppRoutes.MANAGE_SUBSCRIPTIONS,
        element: <ManageSubscriptions />,
      },
      {
        path: AppRoutes.MANAGE_SUBSCRIPTIONS_CANCEL_REASON,
        element: <ManageSubscriptionsCancelReason />,
      },
      {
        path: AppRoutes.MANAGE_SUBSCRIPTIONS_CANCEL_CONFIRM,
        element: <ManageSubscriptionsCancelConfirm />,
      },
      {
        path: AppRoutes.MANAGE_SUBSCRIPTIONS_EDIT,
        element: <ManageSubscriptionsEdit />,
      },
      {
        path: AppRoutes.MANAGE_SUBSCRIPTIONS_EDIT_RESULT,
        element: <ManageSubscriptionEditResult />,
      },
      {
        path: AppRoutes.MANAGE_SUBSCRIPTIONS_RETENTION_OFFERS,
        element: <ManageSubscriptionsRetentionOffers />,
      },
      {
        path: AppRoutes.TRACKER_TRANSFER_OFFER,
        element: <TransferTrackerOffer />,
      }
    ],
  },
  {
    path: AppRoutes.UNKNOWN,
    element: <Unknown />,
  },
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={router} />
      </I18nextProvider>
    </Provider>
  </React.StrictMode>
);
